declare global {
  interface Window {
    gtag?: (...args: any[]) => void
    dataLayer?: any[]
  }
}

export const getGAClientId = (): Promise<string | null> => {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') {
      resolve(null)
      return
    }

    const attemptGetClientId = () => {
      if (window.gtag && typeof window.gtag === 'function') {
        try {
          window.gtag('get', import.meta.env.VITE_GA4_MEASUREMENT_ID, 'client_id', (clientId: string) => {
            resolve(clientId || null)
          })

          setTimeout(() => {
            resolve(null)
          }, 2000)
        } catch (error) {
          resolve(null)
        }
      }
    }

    attemptGetClientId()
  })
}

export const getGASessionId = (): Promise<string | null> => {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') {
      resolve(null)
      return
    }

    const attemptGetSessionId = () => {
      if (window.gtag && typeof window.gtag === 'function') {
        try {
          window.gtag('get', import.meta.env.VITE_GA4_MEASUREMENT_ID, 'session_id', (sessionId: string) => {
            resolve(sessionId || null)
          })

          setTimeout(() => {
            resolve(null)
          }, 2000)
        } catch (error) {
          resolve(null)
        }
      }
    }

    attemptGetSessionId()
  })
}
